export const STYLING_WIDESCREEN = {
  typography: {
    fontFamily: "Montserrat, Aerial",
  },
  app: {
    height: "100vh",
  },
  homePage: {
    flexDirection: "row",
  },
  aboutTheProgramme: {
    imgWidth: "30%",
    headingFontSize: "6rem",
    subHeadingFontSize: "4rem",
    subHeadingWidth: "60%",
  },
  aboutWastewater: {
    width: "30%",
    height: "100%",
    heading: "4rem",
    headingBottomPadding: "40px",
    subHeading: "4rem",
    exploreButtonTextSize: "4rem",
    paddingBottom: "0px",
  },
  howItCanBeUsed: {
    width: "30%",
    height: "100%",
    heading: "4rem",
    headingBottomPadding: "40px",
    subHeading: "4rem",
    exploreButtonTextSize: "4rem",
    paddingBottom: "0",
  },
  findOutMore: {
    paddingTop: "80px",
    width: "30%",
    height: "100%",
    heading: "4rem",
    headingPaddingTop: "20px",
    buttonHeight: "120px",
    buttonTextSize: "4rem",
    exploreButtonTextSize: "4rem",
    wrapperBoxPaddingTop: "50px",
    findOutButtonsWrapperBox: {
      height: "100%",
      paddingBottom: "35px",
    },
    spanStyling: {
      width: "20%",
      height: "75%",
    },
  },
  overview: {
    height: "calc(100% - 200px)",
    heading: "4rem",
    body: "2.5rem",
    width: "50%",
    top: "0",
    right: "0",
    paddingBottom: "180px",
    wrapperBox: {
      width: "75%",
      height: "60%",
      rotation: "rotate(-1deg)",
    },
    button: {
      fontSize: "2.5rem",
    },
  },
  exitButton: {
    fontSize: "2.5rem",
    iconSize: "3rem",
  },
  exploreButton: {
    bottom: 50,
    top: null,
    fontSize: "4rem",
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  subAreaInfo: {
    height: "80%",
    width: "35%",
    bottom: null,
    top: 130,
    right: -5,
    heading: "4rem",
    subHeading: "3rem",
    body: "2.5rem",
    wrapperBox: {
      borderRadius: "0px",
      rotation: "rotate(-1deg)",
    },
    contentWrapperBox: {
      width: "calc(100% - 100px)",
      height: "calc(100% - 100px)",
      rotation: "none",
      padding: "50px",
    },
    categoryWrapper: {
      paddingBottom: "25px",
    },
  },
  categoriesNonMobile: {
    fontSize: "2rem",
  },
  nextScenarioNonMobile: {
    width: "30%",
    height: "300px",
    headingFontSize: "2.5rem",
    nextScenarioButton: {
      fontSize: "4rem",
      textSize: "1.5rem",
    },
  },
  redLine: {
    width: "87%",
  },
  areaButtons: {
    height: "75%",
    top: 125,
    fontSize: "2rem",
    minWidth: "500px",
    buttonHeight: "100px",
    backButtonFontSize: "2rem",
    backButtonHeight: "100px",
    backButtonMinWidth: "250px",
  },
  landingPage: {
    height: "100%",
  },
  scenarioSign: {
    top: 80,
    fontSize: "3.5rem",
    height: "100px",
  },
  modelViewer: {
    width: "100%",
    position: "unset",
    top: null,
  },
  annotation: {
    heightUnselected: "200px",
    heightSelected: "100px",
    signFontSize: "2.5rem",
    maxWidth: "max-content",
  },
  topMenu: {
    imgSrc: "Assets/Svgs/Water Tales Logo.svg",
    imgHeight: "90%",
    topMenuHeight: "10%",
    padding: "40px",
    width: "calc(100% - 80px)",
  },
  aboutIsland: {
    width: "30%",
  },
  resourceIsland: {
    height: "25%",
    width: "30%",
    justifyContent: "flex-end",
    imgWidth: "40%",
  },
};
